import { findParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';
export var findParentExpandNode = function findParentExpandNode(state) {
  return findParentNodeOfType(state.schema.nodes.nestedExpand)(state.selection) || findParentNodeOfType(state.schema.nodes.expand)(state.selection);
};